
<template>
    <component :is="'div'">

        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="testimonialData === undefined"
        >
            <h4 class="alert-heading">Error al obtener los datos del testimonio</h4>
            <div class="alert-body">
                No se encontró ningún testimonio con este id. Verificar en la
                <b-link
                    class="alert-link"
                    :to="{ name: 'testimonials'}"
                >
                    Lista de testimonios
                </b-link>
                para buscar otro testimonio
            </div>
        </b-alert>

        <testimonial-edit-tab-information
            v-if="testimonialData"
            :testimonial-data="testimonialData"
        />
    </component>
</template>

<script>

    import TestimonialEditTabInformation from './TestimonialEditTabInformation.vue';
    import testimonialStoreModule from '../testimonialStoreModule';
    import { onUnmounted, ref } from '@vue/composition-api';
    import router from '@/router';
    import store from '@/store';

    export default {
        components: {
            TestimonialEditTabInformation
        },
        setup() {
            const testimonialData = ref(null);

            const TESTIMONIAL_APP_STORE_MODULE_NAME = 'app-testimonial';

            // Register module
            if (!store.hasModule(TESTIMONIAL_APP_STORE_MODULE_NAME)) store.registerModule(TESTIMONIAL_APP_STORE_MODULE_NAME, testimonialStoreModule);

            // UnRegister on leave
            onUnmounted(() => {
                if (store.hasModule(TESTIMONIAL_APP_STORE_MODULE_NAME)) store.unregisterModule(TESTIMONIAL_APP_STORE_MODULE_NAME)
            });

            store.dispatch('app-testimonial/fetchTestimonial', { id: router.currentRoute.params.id })
                .then(response => {
                    if (response.data === 'error') {
                        testimonialData.value = undefined
                    } else {
                        testimonialData.value = response.data;
                    }
                })
                .catch(error => {
                    if (error.response.status === 404) {
                        testimonialData.value = undefined
                    }
                });

            return {
                testimonialData
            }
        }
    }

</script>
